module.exports = __webpack_public_path__ + "img/logo_home.3f9c7be6.png";